/* eslint-disable import/prefer-default-export */
export const drugListByAlphabates = [
  {
    letter: 'A',
    list: [
      'ADHD (5)',
      'Acne (344)',
      'Alcohol Addiction (12)',
      'Allergies (955)',
      'Alzhiemer (146)',
      'Amoebiasis (19)',
      'Anaemia (471)',
      'Anaesthesia - Local (55)',
      'Anaesthesia General (1)',
      'Anal Fissure (0)',
      'Angina (281)',
      'Anti-Scar (0)',
      'Anxiety (36)',
      'Appetite (49)',
      'Arrhythmiasis (23)',
      'Arthritis (136)',
      'Asthma/COPD (720)',
      'Auto Immune Disease (279)',
      'Ayurvedic Medicine (65)',
    ],
  },
  {
    letter: 'B',
    list: [
      'Bacterial Infections (186)',
      'Bladder And Prostate Disorders (304)',
      'Bleeding Disorders (145)',
      'Blood Clot (633)',
      'Bone Metabolism (104)',
      'Burns (1)',
    ],
  },
  {
    letter: 'C',
    list: [
      'CNS stimulants (1)',
      'Cancer/Oncology (1268)',
      'Cholelithiasis/Gall Stones (125)',
      'Cleanser (176)',
      'Constipation (277)',
      'Contraception (70)',
      'Cough And Cold (921)',
      'Crack (1)',
    ],
  },
  {
    letter: 'D',
    list: [
      'Dandruff (66)',
      'Denture Adhesive (3)',
      'Depression (473)',
      'Diabetes (4030)',
      'Diagnostic (9)',
      'Diarrhoea (242)',
      'Dietary Management (1)',
      'Digestion (117)',
      'Dry Eye (198)',
      'Dry Skin (608)',
    ],
  },
];
